import { render, staticRenderFns } from "./AdjustmentPremiumPreview.vue?vue&type=template&id=15c82daa&scoped=true"
import script from "./AdjustmentPremiumPreview.vue?vue&type=script&lang=js"
export * from "./AdjustmentPremiumPreview.vue?vue&type=script&lang=js"
import style0 from "./AdjustmentPremiumPreview.vue?vue&type=style&index=0&id=15c82daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c82daa",
  null
  
)

export default component.exports